"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/shared-savings-goal.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Fshared-savings-goal.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingUpdate = void 0;
const protobufPackage = 'com.step.account.proto';
function createBaseMatchingUpdate() {
    return { userId: '', matching: false };
}
exports.MatchingUpdate = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            matching: isSet(object.matching) ? globalThis.Boolean(object.matching) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.matching !== false) {
            obj.matching = message.matching;
        }
        return obj;
    },
    create(base) {
        return exports.MatchingUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMatchingUpdate();
        message.userId = object.userId ?? '';
        message.matching = object.matching ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=shared-savings-goal.js.map